module.exports = __webpack_public_path__ + "3b250a5534f1b358cca1351ac1032be2.png";